import "./DesktopLogin.css";
import { useMemo } from "react";
import { useLang } from "../../../i18n/LangContext";

export default function DesktopRegisterSuccess({ open, email = "", onClose = () => {} }) {
  const { t } = useLang();
  const copy = useMemo(() => t.registerSuccess || {
    eyebrow: "VERIFY EMAIL",
    title: "Check your email",
    subtitle: "We sent a verification link to your inbox. Please confirm to finish your registration.",
    cta: "Got it",
  }, [t.registerSuccess]);

  if (!open) return null;

  const subtitle = (copy.subtitle || "").replace("{email}", email || "your email");

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="desktop-login-overlay" role="dialog" aria-modal="true" onMouseDown={handleBackdrop}>
      <div className="desktop-login-card">
        <button
          type="button"
          className="desktop-login-close"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>
        <p className="desktop-login-eyebrow">{copy.eyebrow}</p>
        <h2 className="desktop-login-title">{copy.title}</h2>
        <p className="desktop-login-subtitle">{subtitle}</p>
        <button type="button" className="desktop-login-submit" onClick={onClose}>
          <span>{(copy.cta || "OK").toUpperCase()}</span>
        </button>
      </div>
    </div>
  );
}
